import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isPristine, isSubmitting, reset } from 'redux-form';
import { connect } from 'react-redux';

import ActionButton from 'jbc-front/components/ActionButton';
import { Edit, Task, Revert, Strage, MinusCircle, Pulldown } from 'jbc-front/components/icons';
import { PAY_DETAIL_PDF } from 'src/constants/EndpointUrls';
import PreviewPdfModalContainer from 'src/containers/PreviewPdfModalContainer';
import { EMPLOYEE_PAY_FORM } from 'src/constants/FormNames';

import Balloon from './Balloon';
import RollbackEmployeePayModalContainer from '../containers/RollbackEmployeePayModalContainer';

import styles from './EmployeePayForm.scss';

const EmployeePayButtonGroups = ({
  isViewOnly,
  disabledEditBtn,
  submit,
  submitting,
  pristine,
  hasRunningPayJobs,
  changeViewModeToFalse,
  changeViewModeToTrue,
  paymentMonthConfirmed,
  clearRollbackError,
  employeePayId,
  dispatch
}) => {
  const [isPdfPreview, setIsPdfPreview] = useState(false);
  const [isRollbackModalOpen, setIsRollbackModalOpen] = useState(false);
  const [isPdfExportBallonOpen, setIsPdfExportBallonOpen] = useState(false);
  const [isEnLanguage, setIsEnLanguage] = useState(false);
  const { t } = useTranslation();

  const disabledEditReason = hasRunningPayJobs
    ? t('features.EmployeePays.components.EmployeePayButtonGroups.Cannot_edit_because_salary_information_is_being_updated')
    : null;

  const showPreview = () => {
    setIsPdfPreview(true);
  };
  const hidePreview = () => {
    setIsPdfPreview(false);
  };

  const handleDownloadPDF = isEnglish => {
    setIsEnLanguage(isEnglish);
    showPreview();
  };

  const handleResetForm = () => {
    dispatch(reset(EMPLOYEE_PAY_FORM));
    changeViewModeToTrue();
  };

  return (
    <div className={styles.buttons}>
      <div className={styles.buttonsLeft}>
        {isViewOnly ? (
          <ActionButton disabled={disabledEditBtn} disabledReason={disabledEditReason} onClick={changeViewModeToFalse} icon={<Edit size={15} />}>
            {t('features.EmployeePays.components.EmployeePayButtonGroups.edit')}
          </ActionButton>
        ) : (
          <div>
            <ActionButton onClick={submit} disabled={pristine || submitting || disabledEditBtn} disabledReason={disabledEditReason} icon={<Strage size={15} />}>
              {t('features.EmployeePays.components.EmployeePayButtonGroups.save')}
            </ActionButton>
            <ActionButton onClick={handleResetForm} disabled={submitting} icon={<MinusCircle size={15} />}>
              {t('features.EmployeePays.components.EmployeePayButtonGroups.cancel')}
            </ActionButton>
          </div>
        )}
      </div>
      <div className={styles.buttonsLeft}>
        <ActionButton primary icon={<Task size={15} />} onClick={() => setIsPdfExportBallonOpen(true)} disabled={!paymentMonthConfirmed}>
          {t('features.EmployeePays.components.EmployeePayButtonGroups.PDF_export')}
        </ActionButton>
        {isPdfExportBallonOpen && (
          <Balloon style={{ top: '24px' }} hide={() => setIsPdfExportBallonOpen(false)}>
            <ul className={styles.links}>
              {[false, true].map(isEnglish => (
                <li key={`isEnglish-${isEnglish}`}>
                  {/* ESlint does not allow to use onClick in <a></a> tag */}
                  {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
                  <a onClick={() => handleDownloadPDF(isEnglish)}>
                    <Pulldown size={10} />
                    {t(`features.EmployeePays.components.EmployeePayButtonGroups.export_${isEnglish ? 'en' : 'vi'}`)}
                  </a>
                </li>
              ))}
            </ul>
          </Balloon>
        )}
      </div>

      <div className={styles.buttonsRight}>
        <span>
          <ActionButton icon={<Revert size={14} />} disabled={paymentMonthConfirmed} onClick={() => setIsRollbackModalOpen(true)}>
            {t('features.EmployeePays.components.EmployeePayButtonGroups.back_to_before_manual_input')}
          </ActionButton>
          <RollbackEmployeePayModalContainer
            isOpen={isRollbackModalOpen}
            hideModal={() => {
              setIsRollbackModalOpen(false);
              clearRollbackError();
            }}
            employeePayId={employeePayId}
          />
        </span>
        <PreviewPdfModalContainer
          header={t('features.EmployeePays.components.EmployeePayButtonGroups.payslip')}
          isOpen={isPdfPreview}
          hideModal={hidePreview}
          url={`${PAY_DETAIL_PDF}?id=${employeePayId}&language=${isEnLanguage ? 'en' : 'vi'}`}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  pristine: isPristine(EMPLOYEE_PAY_FORM)(state),
  submitting: isSubmitting(EMPLOYEE_PAY_FORM)(state)
});

export default connect(mapStateToProps)(EmployeePayButtonGroups);
